export const WATER_SYSTEM_CLASS_TYPES = [
  {code: 'A', value: 'A'},
  {code: 'B', value: 'B'},
  {code: 'C', value: 'C'},
  {code: 'D', value: 'D'},
  {code: 'E', value: 'E'},
  {code: 'X', value: 'Not applicable'}
];